module.exports = __webpack_public_path__ + "img/dots.9bc18780.svg";